import React, { useState, useEffect } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import Footer from '../Footer/Footer';
import Navbar from '../Navbar/Navbar';
import { FaArrowUp } from 'react-icons/fa';
import styles from './Layout.module.css';
import { useAuth } from '../Context/Auth';
import { toast } from 'react-hot-toast';

export default function Layout() {
  const { isLoggedIn } = useAuth();
  const location = useLocation();
  const [showArrow, setShowArrow] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [toastShown, setToastShown] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowArrow(window.scrollY > 200);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const publicPages = ['/', '/login', '/register'];
    const token = localStorage.getItem('token');
    const loggedIn = isLoggedIn || !!token;

    if (!loggedIn && !publicPages.includes(location.pathname)) {
      if (!toastShown) {
        toast.error('⚠️ Please Login first to access this page!', {
          style: { fontSize: '16px', background: '#ff4d4d', color: '#fff', fontWeight: 'bold' },
          duration: 4000,
        });
        setToastShown(true);
      }
      const timer = setTimeout(() => setRedirect(true), 50);
      return () => clearTimeout(timer);
    } else {
      setToastShown(false);
      setRedirect(false);
    }
  }, [isLoggedIn, location.pathname, toastShown]);

  if (redirect) return <Navigate to="/login" replace />;

  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
      {showArrow && (
        <button onClick={scrollToTop} className={styles.scrollButton}>
          <FaArrowUp />
        </button>
      )}
    </>
  );
}
